import image from "@/app/reviews/images/video-image/testimonial1.jpg";
import image1 from "@/app/reviews/images/video-image/testimonial2.jpg";
import image2 from "@/app/reviews/images/video-image/testimonial3.jpg";
import image3 from "@/app/reviews/images/video-image/testimonial4.jpg";
import image4 from "@/app/reviews/images/video-image/testimonial5.jpg";
import image5 from "@/app/reviews/images/video-image/testimonial6.jpg";
import image6 from "@/app/reviews/images/video-image/testimonial7.jpg";
import image7 from "@/app/reviews/images/video-image/testimonial8.jpg";
import image8 from "@/app/reviews/images/video-image/testimonial9.jpg";
import image9 from "@/app/reviews/images/video-image/testimonial10.jpg";
import image10 from "@/app/reviews/images/video-image/testimonial11.jpg";
import image11 from "@/app/reviews/images/video-image/testimonial12.jpg";
import image12 from "@/app/reviews/images/video-image/testimonial13.jpg";
import image13 from "@/app/reviews/images/video-image/testimonial14.jpg";
import image14 from "@/app/reviews/images/video-image/testimonial15.jpg";
import image15 from "@/app/reviews/images/video-image/testimonial16.jpg";
import image23 from "@/app/reviews/images/video-image/testimonial17.jpeg";
import image16 from "@/app/reviews/images/video-image/testimonial1.jpeg";
import image17 from "@/app/reviews/images/video-image/testimonial2.jpeg";
import image18 from "@/app/reviews/images/video-image/testimonial3.jpeg";
import image19 from "@/app/reviews/images/video-image/testimonial4.jpeg";
import image20 from "@/app/reviews/images/video-image/testimonial5.jpeg";
import image21 from "@/app/reviews/images/video-image/testimonial6.jpeg";
import image22 from "@/app/reviews/images/video-image/testimonial7.jpeg";
import video1 from "@/app/reviews/images/video-image/video1.jpg";
import video2 from "@/app/reviews/images/video-image/video2.jpg";
import video3 from "@/app/reviews/images/video-image/video3.jpg";
import video4 from "@/app/reviews/images/video-image/video4.jpg";
import video5 from "@/app/reviews/images/video-image/video5.jpg";
import video6 from "@/app/reviews/images/video-image/video6.jpg";
import video7 from "@/app/reviews/images/video-image/video7.jpg";
import video8 from "@/app/reviews/images/video-image/video8.jpg";
import video9 from "@/app/reviews/images/video-image/video9.jpg";
import video10 from "@/app/reviews/images/video-image/video10.jpg";
import video11 from "@/app/reviews/images/video-image/video11.jpg";
import video12 from "@/app/reviews/images/video-image/video12.jpg";
import video13 from "@/app/reviews/images/video-image/video13.jpg";
import video14 from "@/app/reviews/images/video-image/video14.jpg";
import video15 from "@/app/reviews/images/video-image/video15.jpg";
import video16 from "@/app/reviews/images/video-image/video16.jpg";
import video17 from "@/app/reviews/images/video-image/video17.jpg";
import video18 from "@/app/reviews/images/video-image/video18.jpg";
import video19 from "@/app/reviews/images/video-image/video19.jpg";
import video20 from "@/app/reviews/images/video-image/video20.jpg";
import video21 from "@/app/reviews/images/video-image/video21.jpg";
import video22 from "@/app/reviews/images/video-image/video22.jpg";
import video23 from "@/app/reviews/images/video-image/video23.jpg";
import video24 from "@/app/reviews/images/video-image/video24.jpg";
import video25 from "@/app/reviews/images/video-image/video25.jpg";
import video26 from "@/app/reviews/images/video-image/video26.jpg";
import video27 from "@/app/reviews/images/video-image/video27.jpg";
import video28 from "@/app/reviews/images/video-image/video28.jpg";
import video29 from "@/app/reviews/images/video-image/video29.jpg";
import video30 from "@/app/reviews/images/video-image/video30.jpg";
import video31 from "@/app/reviews/images/video-image/video31.jpg";
import video32 from "@/app/reviews/images/video-image/video32.jpg";
import video33 from "@/app/reviews/images/video-image/video33.jpg";
import video34 from "@/app/reviews/images/video-image/video34.jpg";
import video35 from "@/app/reviews/images/video-image/video35.jpg";
import video36 from "@/app/reviews/images/video-image/video36.jpg";
import video37 from "@/app/reviews/images/video-image/video37.jpg";
import video38 from "@/app/reviews/images/video-image/video38.jpg";
import video39 from "@/app/reviews/images/video-image/video39.jpg";
import video40 from "@/app/reviews/images/video-image/video40.jpg";
import video41 from "@/app/reviews/images/video-image/video41.jpg";


const imageData = {
    videoData: [
        {
            image: image,
            path: "",
        },
        {
            image: image1,
            path: "",
        },
        {
            image: image2,
            path: "",
        },
        {
            image: image3,
            path: "",
        },
        {
            image: image4,
            path: "",
        },
        {
            image: image5,
            path: "",
        },
        {
            image: image6,
            path: "",
        },
        {
            image: image7,
            path: "",
        },
        {
            image: image8,
            path: "",
        },
        {
            image: image9,
            path: "",
        },
        {
            image: image10,
            path: "",
        },
        {
            image: image11,
            path: "",
        },
        {
            image: image12,
            path: "",
        },
        {
            image: image13,
            path: "",
        },
        {
            image: image14,
            path: "",
        },
        {
            image: image15,
            path: "",
        },
        {
            image: image16,
            path: "",
        },
        {
            image: image17,
            path: "",
        },
        {
            image: image18,
            path: "",
        },
        {
            image: image19,
            path: "",
        },
        {
            image: image20,
            path: "",
        },
        {
            image: image21,
            path: "",
        },
        {
            image: image22,
            path: "",
        },
        {
            image: image23,
            path: "",
        },
        {
            image: video1,
            path: "https://youtu.be/0jWtzNNZF50?si=zXk6IaxtTTIJIxLF",
        },
        {
            image: video2,
            path: "https://youtu.be/1ipT8bG2RjI?si=O6TkS8YVZpJ0xOag",
        },
        {
            image: video3,
            path: "https://youtu.be/3y92mdEUKdY?si=rrTSy5EBl4CawXUh",
        },
        {
            image: video4,
            path: "https://youtu.be/9scRCso_YOo?si=j88IoDfRgzDvkoGh",
        },
        {
            image: video5,
            path: "https://youtu.be/A37vot7oG9Y?si=3M3xo1KtiODNw-GZ",
        },
        {
            image: video6,
            path: "https://youtu.be/Aje6QMPrYzk?si=EwSAymzK4u0ltNfk",
        },
        {
            image: video7,
            path: "https://youtu.be/Aje6QMPrYzk?si=r4i-e0OzRL9G4rdE",
        },
        {
            image: video8,
            path: "https://youtu.be/AjK5Tld8OQg?si=lp85v7GkfCtyZi8A",
        },
        {
            image: video9,
            path: "https://youtu.be/AKLLPg9fRCw?si=qqos1xkqEQrDo0qp",
        },
        {
            image: video10,
            path: "https://youtu.be/AVeZvoESpKI?si=GH5M2qEW_6jsMKXL",
        },
        {
            image: video11,
            path: "https://youtu.be/BMnR5mqz8tM?si=ZJz4bUKzOX1Z_jOu",
        },
        {
            image: video12,
            path: "https://youtu.be/CWls6PsYDZM?si=OLLx03pIY7TntVxX",
        },
        {
            image: video13,
            path: "https://youtu.be/d37QQJyUkP0?si=IDqv-dCieQLqvU-x",
        },
        {
            image: video14,
            path: "https://youtu.be/eCsdJzZh2Qw?si=T1K-8peORdrlTfz9",
        },
        {
            image: video15,
            path: "https://youtu.be/eks-lqhYpsA?si=E-P4ofWgLqKOG3Zf",
        },
        {
            image: video16,
            path: "https://youtu.be/Em-cKYV05ok?si=p1fnJls2UBUIWwFy",
        },
        {
            image: video17,
            path: "https://youtu.be/gbLZ0P17Mf0?si=Gji0EWEZUBUNOXpq",
        },
        {
            image: video18,
            path: "https://youtu.be/GKWfWwpPlWU?si=o8i6VigB11PmHrFd",
        },
        {
            image: video19,
            path: "https://youtu.be/hkt26H9S6no?si=ztIFoZMGosEw1i_c",
        },
        {
            image: video20,
            path: "https://youtu.be/iAetjYeSG3A?si=es1zW_7xLKLft5U7",
        },
        {
            image: video21,
            path: "https://youtu.be/jpG43fj5WZM?si=49Tsv0f2dmc7g8iu",
        },
        {
            image: video22,
            path: "https://youtu.be/Jzx2hVisdYA?si=DJ8NCdCajagImfJe",
        },
        {
            image: video23,
            path: "https://youtu.be/K-9IiKtr8AM?si=GaU-ZjtLRf4eXH3Y",
        },
        {
            image: video24,
            path: "https://youtu.be/N8VLEEA6s2w?si=PZR3e1BhQTnXs7le",
        },
        {
            image: video25,
            path: "https://youtu.be/OBTFqa1llnw?si=uai_bg57XIILc4eG",
        },
        {
            image: video26,
            path: "https://youtu.be/OKNlCPZBEbU?si=RoJxkX7EewgFyWrO",
        },
        {
            image: video27,
            path: "https://youtu.be/p1eHDeFfBs0?si=Wyyl_0TbdlS7chxB",
        },
        {
            image: video28,
            path: "https://youtu.be/qERm5FOBilk?si=Kcta5mWuEk9WiBZu",
        },
        {
            image: video29,
            path: "https://youtu.be/qV5uiFUKNj4?si=vKkgcrjMUhfYDlJJ",
        },
        {
            image: video30,
            path: "https://youtu.be/RJ4rSeHlfCs?si=uJj9-3XBOJ8nC2Me",
        },
        {
            image: video31,
            path: "https://youtu.be/rNud4fSMi-0?si=FDYfwNV7lzgHosZB",
        },
        {
            image: video32,
            path: "https://youtu.be/sRTGFQorlYE?si=nVv_Xpn4JGw345MN",
        },
        {
            image: video33,
            path: "https://youtu.be/UHJwORfXGDk?si=iN3YqMGvQTWCms5b",
        },
        {
            image: video34,
            path: "https://youtu.be/_uXdNkxtXek?si=55J9Tgzxb_21iUwN",
        },
        {
            image: video35,
            path: "https://youtu.be/UzOdBsIbPXI?si=p3I58S_GlkzGYvQB",
        },
        {
            image: video36,
            path: "https://youtu.be/VFfNfjHsU3k?si=UOowhJHNzfAI0MzX",
        },
        {
            image: video37,
            path: "https://youtu.be/w13YRUoNtBQ?si=M1mDWFyRhecTF7FX",
        },
        {
            image: video38,
            path: "https://youtu.be/XQdPeKs2KsM?si=tYuUBBwMgaLS1YrF",
        },
        {
            image: video39,
            path: "https://youtu.be/_-ya1zb6xnU?si=-f4CBywxvnifiiQM",
        },
        {
            image: video40,
            path: "https://youtu.be/znpXugjIsmo?si=qR1xpdCUDuztR82u",
        },
        {
            image: video41,
            path: "https://youtu.be/ZP3cuPuv9D4?si=3vOMPu1OIEB0kptM",
        },
    ],
};


export default imageData;